import ACTIONS from "./types";

export const fireErrorAlert = (message, options) => dispatch => {
  dispatch({
    type: ACTIONS.ALERT.FIRE_ERROR_ALERT,
    payload: { message, options }
  });
};

export const endErrorAlert = () => dispatch => {
  dispatch({
    type: ACTIONS.ALERT.END_ERROR_ALERT
  });
};
